import { useState, useEffect, useCallback } from "react";
import { Button } from "antd";
import { UserPlus } from "lucide-react";
import { renderErrorNotifications } from "helpers/error.helpers";
import { listTeamMembers, revokeMember } from "./team.service";
import MembersTable from "./_blocks/MembersTable";
import AddMemberModal from "./_blocks/AddMemberModal";

function Team() {
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [addOpen, setAddOpen] = useState(false);
  const [revokingId, setRevokingId] = useState(null);

  const loadMembers = useCallback(async ({ showLoading = false } = {}) => {
    if (showLoading) setLoading(true);
    const { data, errors } = await listTeamMembers();
    setLoading(false);
    if (errors?.length > 0) {
      renderErrorNotifications(errors);
      return;
    }
    setMembers(data?.data ?? []);
  }, []);

  useEffect(() => {
    loadMembers({ showLoading: true });
  }, [loadMembers]);

  const handleRevoke = async (memberId) => {
    setRevokingId(memberId);
    const { errors } = await revokeMember(memberId);
    setRevokingId(null);
    if (errors?.length > 0) {
      renderErrorNotifications(errors);
      return;
    }
    await loadMembers();
  };

  const handleAdded = async () => {
    setAddOpen(false);
    await loadMembers();
  };

  return (
    <div className="space-y-6">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
        <div>
          <h1 className="text-2xl font-bold tracking-tight">Team</h1>
          <p className="text-muted-foreground text-sm">
            Give trusted people access to help manage your account. They get
            full access except managing the team.
          </p>
        </div>
        <Button
          type="primary"
          icon={<UserPlus className="h-4 w-4" />}
          onClick={() => setAddOpen(true)}
        >
          Add member
        </Button>
      </div>

      <MembersTable
        members={members}
        loading={loading}
        onRevoke={handleRevoke}
        revokingId={revokingId}
      />

      <AddMemberModal
        open={addOpen}
        onClose={() => setAddOpen(false)}
        onAdded={handleAdded}
      />
    </div>
  );
}

export default Team;
